module.exports = __webpack_public_path__ + "img/prizes-2.13985abd.png";